import { useEffect, useRef } from "react";

// Small bridge between the global setup flow (components/SetupFlow) and the
// screens it sends the user to. Safe to use when the flow is not running:
// nothing listens and nothing is pending.
export const SETUP_PROGRESS_EVENT = "setup-flow-progress";
const SETUP_CREATE_EVENT = "setup-flow-create";

// stepKey: "details" | "company"
// Called by a step's screen after a successful save, so the next step's
// dialog can open.
export const notifySetupProgress = (stepKey) => {
  window.dispatchEvent(
    new CustomEvent(SETUP_PROGRESS_EVENT, { detail: stepKey }),
  );
};

// The flow asks a step's screen to open its create form. The request waits
// here until that screen is mounted and ready, then is used once.
let pendingCreate = null;

export const requestSetupCreate = (stepKey) => {
  pendingCreate = stepKey;
  window.dispatchEvent(new Event(SETUP_CREATE_EVENT));
};

// Called by a screen: runs `open` (the same handler as its Add button) once
// when the flow has asked for this step's create form. `ready` holds it
// back until the screen has loaded.
export const useSetupCreate = (stepKey, open, ready = true) => {
  const openRef = useRef(open);
  openRef.current = open;
  useEffect(() => {
    if (!ready) return undefined;
    const run = () => {
      if (pendingCreate !== stepKey) return;
      pendingCreate = null;
      openRef.current();
    };
    run();
    window.addEventListener(SETUP_CREATE_EVENT, run);
    return () => window.removeEventListener(SETUP_CREATE_EVENT, run);
  }, [ready, stepKey]);
};
